import { Stack } from '@/components/layout';
import { MutateInfoTemplate } from '@/components/template/mutate-info/mutate-info-template';
import { FormInput, FormSelectInput } from '@/components/ui';
import Text from '@/components/ui/text/text';
import { STRINGS } from '@/constants/strings';
import { useMutateCoach } from '@/features/coach/hooks/use-mutate-coach';
import { STATE_OPTIONS } from '@/features/player/components/mutate-player/constants';
import { useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import { Controller } from 'react-hook-form';

export function MutateCoachScreen() {
  const logics = useMutateCoach();
  const title = STRINGS.mutateCoach.title;
  const { scale, isTablet } = useScaling();
  const rowGap = scale(16);
  const control = logics.form.control;
  const setValue = logics.form.setValue;
  const stateOptions = STATE_OPTIONS;

  return (
    <MutateInfoTemplate title={{ create: title, edit: title }} logics={logics}>
      <Stack gap={rowGap} width="100%">
        {isTablet ? (
          <Text variant="Font Inter/Subtitle/Bold 14px" style={{ color: colors.Blue }}>
            {STRINGS.mutateCoach.profile.editContactInfo}
          </Text>
        ) : (
          <Text
            fontFamily="Montserrat"
            fontSize={scale(11)}
            fontWeight="700"
            letterSpacing={0}
            lineHeight={scale(11) * 1.4}
            style={{ color: colors.Blue }}>
            {STRINGS.mutateCoach.profile.editContactInfo}
          </Text>
        )}
        <Controller
          name="phoneNumber"
          control={control}
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
            <FormInput
              label={STRINGS.mutateCoach.profile.phoneNumber}
              required={false}
              value={value}
              maxLength={24}
              trim
              status={error?.message ? 'error' : 'default'}
              errorMessage={error?.message}
              keyboardType="phone-pad"
              onBlur={onBlur}
              onChangeText={altPhoneNumber => onChange(altPhoneNumber)}
              placeholder={''}
              onCountryCodeChange={countryCode => setValue('countryCode', countryCode)}
              phoneNumber
            />
          )}
        />
        <Controller
          name="streetAddress"
          control={control}
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
            <FormInput
              label={STRINGS.mutateCoach.profile.streetAddress}
              required={false}
              value={value}
              status={error?.message ? 'error' : 'default'}
              errorMessage={error?.message}
              maxLength={200}
              onBlur={onBlur}
              onChangeText={streetAddress => onChange(streetAddress)}
              placeholder={STRINGS.mutateCoach.profile.streetAddressPlaceholder}
            />
          )}
        />
        <Controller
          name="streetAddress2"
          control={control}
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
            <FormInput
              label={STRINGS.mutateCoach.profile.streetAddress2}
              required={false}
              value={value}
              status={error?.message ? 'error' : 'default'}
              errorMessage={error?.message}
              maxLength={200}
              onBlur={onBlur}
              onChangeText={streetAddress2 => onChange(streetAddress2)}
              placeholder={STRINGS.mutateCoach.profile.streetAddress2Placeholder}
            />
          )}
        />
        <Controller
          name="city"
          control={control}
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
            <FormInput
              label={STRINGS.mutateCoach.profile.city}
              required={false}
              value={value}
              status={error?.message ? 'error' : 'default'}
              errorMessage={error?.message}
              maxLength={100}
              onBlur={onBlur}
              onChangeText={city => onChange(city)}
              placeholder={STRINGS.mutateCoach.profile.city}
            />
          )}
        />
        <Stack direction={isTablet ? 'row' : 'column'} gap={rowGap} width="100%">
          <Stack flex={isTablet ? 1 : undefined}>
            <Controller
              name="state"
              control={control}
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <FormSelectInput
                  label={STRINGS.mutateCoach.profile.state}
                  required={false}
                  options={stateOptions}
                  value={value}
                  status={error?.message ? 'error' : 'default'}
                  errorMessage={error?.message}
                  onValueChange={state => onChange(state)}
                  placeholder={STRINGS.mutateCoach.profile.state}
                />
              )}
            />
          </Stack>
          <Stack flex={isTablet ? 1 : undefined}>
            <Controller
              name="zipCode"
              control={control}
              render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
                <FormInput
                  label={STRINGS.mutateCoach.profile.zipCode}
                  required={false}
                  value={value}
                  status={error?.message ? 'error' : 'default'}
                  errorMessage={error?.message}
                  keyboardType="numeric"
                  maxLength={15}
                  onBlur={onBlur}
                  onChangeText={zipCode => onChange(zipCode.replace(/[^0-9]/g, ''))}
                  placeholder={STRINGS.mutateCoach.profile.zipCode}
                />
              )}
            />
          </Stack>
        </Stack>
      </Stack>
    </MutateInfoTemplate>
  );
}
